import {
  FETCH_BROKER_LOGIN_URLS_REQUEST,
  FETCH_BROKER_LOGIN_URLS_SUCCESS,
  FETCH_BROKER_LOGIN_URLS_FAILURE,
} from '../../constants/ActionTypes';

const brokerLoginUrls = (
  state = { data: {}, isFetching: false, error: null },
  action
) => {
  switch (action.type) {
    case FETCH_BROKER_LOGIN_URLS_REQUEST:
      return { ...state, isFetching: true, error: null };
    case FETCH_BROKER_LOGIN_URLS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.data.data,
      };
    case FETCH_BROKER_LOGIN_URLS_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    default:
      return state;
  }
};

export default brokerLoginUrls;
